import React from 'react';
import './ThreeEqualDivision.less';

interface ThreeEqualDivisionState {

}

interface ThreeEqualDivisionPropType {
    prefixCls?: string;
    floorId: any;
    floorTemplate: any[];
    onFloorClick: Function;
}

class ThreeEqualDivision extends React.Component<ThreeEqualDivisionPropType, ThreeEqualDivisionState> {
    static defaultProps = {
        prefixCls: 'threeEqualDivision',

    };

    render() {
        const {prefixCls, floorId, floorTemplate, onFloorClick} = this.props;
        return (
            <div className={prefixCls}>
                <div className={`${prefixCls}imgBox leftBox`} onClick={() => {
                    onFloorClick && onFloorClick(floorId, floorTemplate[0].moduleName, floorTemplate[0].moduleUrlType, floorTemplate[0].moduleUrl);
                }}>
                    <img src={floorTemplate[0].moduleImgUrl} alt=""/>
                </div>
                <div className={`${prefixCls}imgBox middleBox`} onClick={() => {
                    onFloorClick && onFloorClick(floorId, floorTemplate[1].moduleName, floorTemplate[1].moduleUrlType, floorTemplate[1].moduleUrl);
                }}>
                    <img src={floorTemplate[1].moduleImgUrl} alt=""/>
                </div>
                <div className={`${prefixCls}imgBox rightBox`} onClick={() => {
                    onFloorClick && onFloorClick(floorId, floorTemplate[2].moduleName, floorTemplate[2].moduleUrlType, floorTemplate[2].moduleUrl);
                }}>
                    <img src={floorTemplate[2].moduleImgUrl} alt=""/>
                </div>
            </div>
        );
    }
}

export default ThreeEqualDivision;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/floorModule/threeEqualDivision/ThreeEqualDivision.tsx